// Vendors
import Parallax from "parallax-js";
import { TimelineMax, TweenMax, Expo, Power3, ScrollToPlugin } from "gsap/all";
const scrollPlugin = ScrollToPlugin;

// Utilities
import Config from "../constants/Config";
import { byId, qs, qsa, cls, data } from "./util/dom-utils";
import pubSub from "./util/pubsub";

class Hero {
    constructor(el) {
        // Elements
        this.$el = el;
        this.scene = byId("scene", this.$el);
        this.$explore = qs(".explore");

        this.heroEls = {};

        this.eventAnimationEnd = "hero::animationEnd";
        this.isActive = true;

        this.scrollHandler = this.scrollHandler.bind(this);

        this.setAnimation();
        this.attachEvents();
        this.setElemHeight();
    }

    setElemHeight() {
        let vh = document.documentElement.clientHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    scrollHandler() {
        if (this.parallaxInstance) {
            if (Config.elementInViewport(this.$el)) {
                if (!this.isActive) {
                    this.isActive = true;
                    this.parallaxInstance.enable();
                }
            }
            else {
                if (this.isActive) {
                    this.isActive = false;
                    this.parallaxInstance.disable();
                }
            }
        }

    }

    goTo(pointAnchor) {
        TweenMax.to(window, 1, {
            scrollTo: {
                y: pointAnchor + 10,
                autoKill: false
            },
            ease: Power3.easeInOut
        });
    }

    attachEvents() {

        pubSub.subscribe(Config.events.LOADER_EXIT, () => {
            this.tl.play();
        });

        pubSub.subscribe(this.eventAnimationEnd, () => {
            if (!window.Modernizr.touch) {
                if (!(/Edge\/\d./i.test(navigator.userAgent))) {
                    this.parallaxInstance = new Parallax(this.scene);
                }
            }
        });

        window.addEventListener(Config.events.SCROLL_NATIVE, this.scrollHandler);

        window.addEventListener(Config.events.ORIENTATION_CHANGE, this.setElemHeight);

        // Scroll to Section 1.
        this.$explore.addEventListener(Config.events.CLICK, () => {
            const pointAnchor = qs(".section--1").offsetTop;
            this.goTo(pointAnchor);
        });

    }

    random(min, max) {
        if (max == null) { max = min; min = 0; }
        if (min > max) { var tmp = min; min = max; max = tmp; }
        return min + (max - min) * Math.random();
    }

    setAnimation() {

        this.chars = qsa(".chars", this.el);

        this.tl = new TimelineMax({
            paused: true,
            onComplete: () => {
                cls.add(this.$el, Config.classes.ANIMATED);
                pubSub.publish(this.eventAnimationEnd);
            }
        });

        this.tl.set(".hero__svg--cloud", {
            x: window.Modernizr.touch ? -10 : -50,
            y: 0,
        });

        this.tl.add([
            TweenMax.fromTo(".title-svg .line--1", 1.5, {
                xPercent: -50,
                opacity: 0
            }, {
                    xPercent: 0,
                    opacity: 1,
                    ease: Expo.easeOut
                }),

            TweenMax.fromTo(".title-svg .line--2", 1.5, {
                xPercent: 50,
                opacity: 0
            }, {
                    xPercent: 0,
                    opacity: 1,
                    ease: Expo.easeOut
                })
        ]);

        this.tl.add([
            TweenMax.from(".hero__subtitle", 1, {
                y: "35%",
                opacity: 0,
                skewX: -3,
                ease: Expo.easeOut
            }),
            TweenMax.staggerFrom(".hero__desc p", 1, {
                y: "25%",
                opacity: 0,
                skewX: -2,
                ease: Expo.easeOut
            }, .1)
        ], "-=0.8");

        this.tl.add([
            TweenMax.fromTo(".hero__svg--shadow", 1.1, {
                xPercent: -50,
            }, {
                    xPercent: 0,
                    ease: Expo.easeOut
                }),

            TweenMax.from(".hero__svg--person", 1.1, {
                xPercent: -40,
                opacity: 0,
                delay: 0.1,
                ease: Expo.easeOut
            }),


        ], "-=0.8");

        this.tl.add([
            TweenMax.to(".hero__svg--cloud", 2, {
                x: window.Modernizr.touch ? 0 : 40,
                y: window.Modernizr.touch ? 0 : 15,
                scale: window.Modernizr.touch ? 1.05 : 1.1,
                opacity: 1,
                ease: Expo.easeOut
            }),

            TweenMax.to(".hero__svg--signs", 2, {
                x: -20,
                y: -20,
                opacity: 1
            })
        ], "+=0.4");

        this.tl.add([
            TweenMax.to(".title-svg", 2, {
                rotation: 4,
                x: 200,
                ease: Expo.easeOut
            }),

            TweenMax.to(".title-svg .line--1", 2, {
                // x: 80,
                x: 60,
                rotation: -8,
                ease: Expo.easeOut
            }),
            TweenMax.to(".title-svg .line--2", 2, {
                y: 120,
                rotation: -2,
                ease: Expo.easeOut
            }),

            TweenMax.to(".hero__subtitle", 1.9, {
                x: window.Modernizr.touch ? 15 : 45,
                ease: Expo.easeOut
            }),

            TweenMax.to(".hero__text", 2, {
                x: window.Modernizr.touch ? 0 : 40,
                rotation: 4,
                ease: Expo.easeOut,
                onStart: () => {

                    this.chars.forEach((el) => {
                        TweenMax.to(el, 2, {
                            rotation: data('rotate', el),
                            y: data('y', el),
                            x: 15,
                            ease: Expo.easeOut
                        });
                    });
                }
            })
        ], "-=2");

    }

}

export default Hero;

const _init = () => {

    // Elements
    let $el = qs(".hero");

    if ($el) {
        new Hero($el);
    }
};

_init();
